import { CORE, gateway } from '../../api';

export default {
  gerarArquivoWhatsApp(payload) {
    return gateway.post(`${CORE}/whatsapp/gerar-arquivo`, payload);
  },
};
